import _ from '@lodash';
import TextField from '@material-ui/core/TextField';
import { IMaskInput } from 'react-imask';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { InputAdornment } from '@material-ui/core';
import { Lock } from '@material-ui/icons';
import { determineEditableAccess } from '../EditFormUtils';

function EditFormTextField(props) {
	const { error } = props.fieldState;
	const { value, onChange } = props.field;
	//const { ref, maskRef } = useIMask(props.fieldConfig.mask);
	const [readOnly, setReadOnly] = useState(determineEditableAccess(props.config, props.fieldConfig, props.fieldPrefix));

	const handleOnBlur = () => {
		if (!_.isUndefined(props.fieldConfig.autoCapitalize) && _.isString(value)) {
			let newValue = value;
			if (props.fieldConfig.autoCapitalize === 'upper') {
				newValue = newValue.toUpperCase();
			} else if (props.fieldConfig.autoCapitalize === 'lower') {
				newValue = newValue.toLowerCase();
			} else if (props.fieldConfig.autoCapitalize === 'capitalize') {
				newValue = newValue
					.split(' ')
					.map(s => (s.length > 0 ? s[0].toUpperCase() + s.slice(1) : ''))
					.join(' ');
			}
			if (newValue !== value) {
				onChange(newValue);
			}
		}
	};

	return (
		<TextField
			{...props.field}
			value={!_.isUndefined(value) && value !== null ? value : ''}
			onChange={e => (e.target.value.length > 0 ? onChange(e.target.value) : onChange(null))}
			className={clsx('mt-8 mb-16', props.fieldConfig.className)}
			type={props.fieldConfig.type ? props.fieldConfig.type : 'text'}
			error={error}
			required={props.fieldConfig.required}
			helperText={error ? error.message : props.fieldConfig.helperText}
			label={props.fieldConfig.text}
			id={props.field.name}
			variant="outlined"
			fullWidth
			multiline={props.fieldConfig.multiline || false}
			autoComplete={props.fieldConfig.autoComplete || 'on'}
			//inputRef={ref}
			InputProps={{
				maxLength: props.fieldConfig.maxLength || null,
				readOnly,
				startAdornment: props.fieldConfig.startAdornment,
				endAdornment: readOnly ? (
					<InputAdornment position="end">
						<Lock fontSize="small" color="disabled" />
					</InputAdornment>
				) : (
					props.fieldConfig.endAdornment
				),
				inputComponent: props.fieldConfig.mask ? IMaskInput : undefined,
				inputProps: props.fieldConfig.mask ? props.fieldConfig.mask : undefined
			}}
			onBlur={() => handleOnBlur()}
		/>
	);
}

export default EditFormTextField;
